'use client'
import { Caret } from 'components/icons/Caret'
import { cx } from 'lib/cx'

interface Props {
  options: Array<readonly [string, string]>
  className?: string
  value: string
  onChange(value: string): void
  title?: string
}

export function ControlledSelectInput({
  options,
  className,
  value,
  onChange,
  title,
}: Props) {
  return (
    <span
      className={cx(
        className,
        'w-full flex items-center justify-items-stretch border border-dashed focus-within:border-solid border-current relative',
      )}
    >
      <select
        className="h-48 px-16 appearance-none grow bg-transparent outline-none"
        onChange={(event) => {
          const value = event.target.value
          onChange(value)
        }}
        value={value}
        title={title}
      >
        {options.map(([value, label]) => (
          <option key={value} value={value} className="text-black">
            {label}
          </option>
        ))}
      </select>
      <span className="absolute right-16 pointer-events-none text-8">
        <Caret />
      </span>
    </span>
  )
}
